module.exports = __webpack_public_path__ + "static/media/schoolpic02@2x.eef4ebdb.png";